import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'callback',
    loadComponent: () =>
      import('./features/callback/callback.component').then(
        (m) => m.CallbackComponent
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/shell/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: 'item-mapper',
        title: 'Item Mapper',
        loadComponent: () =>
          import('./features/item-mapper/item-mapper.component').then(
            (m) => m.ItemMapperComponent
          ),
      },
      {
        path: 'mapper-agents',
        title: 'Agents - Item Mapper',
        loadComponent: () =>
          import('./features/agent-manager/agent-manager.component').then(
            (m) => m.AgentManagerComponent
          ),
        data: {
          agentType: 'mapper',
          featureName: 'Item Mapper',
          subtitle: 'Create and test agents that map exam items to the blueprint.',
        },
      },
      {
        path: 'writer-agents',
        title: 'Agents - Item Writer',
        loadComponent: () =>
          import('./features/agent-manager/agent-manager.component').then(
            (m) => m.AgentManagerComponent
          ),
        data: {
          agentType: 'writer',
          featureName: 'Item Writer',
          subtitle: 'Create and test agents that draft new exam items.',
        },
      },
      {
        path: 'verifier-agents',
        title: 'Agents - Item Verifier',
        loadComponent: () =>
          import('./features/agent-manager/agent-manager.component').then(
            (m) => m.AgentManagerComponent
          ),
        data: {
          agentType: 'verifier',
          featureName: 'Item Verifier',
          subtitle: 'Create and test agents that verify exam items.',
        },
      },
      {
        path: 'no-permission',
        title: 'No Permission',
        loadComponent: () =>
          import('./features/no-permission/no-permission.component').then(
            (m) => m.NoPermissionComponent
          ),
      },
      { path: '', redirectTo: 'item-mapper', pathMatch: 'full' },
      {
        path: '**',
        loadComponent: () =>
          import('./features/not-found/not-found.component').then((m) => m.NotFoundComponent),
      },
    ],
  },
];
